import { createContext, useState, useContext } from "react"

export const AppContext = createContext()

const AppProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isModalTutorialDisplayed, setIsModalTutorialDisplayed] = useState(false)

    return (
        <AppContext.Provider
            value={ {
                isLoading,
                setIsLoading,
                isModalTutorialDisplayed,
                setIsModalTutorialDisplayed
            } }
        >
            { children }
        </AppContext.Provider>
    )
}

export const useAppContext = () => {
    const context = useContext(AppContext)

    if (context === undefined){
        throw new Error(`useContext must be used within a Provider`)
    }

    return context
}

export default AppProvider
